













































export default {
  data() {
    return {
      constants: {
        status: '',
        storeId: '',
        roNumber: '',
        txGuid: '',
        statusMessage: '',
        alertType: '',
      },
    };
  },
  mounted() {
    this.$store.dispatch('setPageTitle', this.$route.meta.title);
    if (this.$route.query['Status']) {
      this.constants.status = this.$route.query['Status'];
    }
    if (this.$route.query['StoreId']) {
      this.constants.storeId = this.$route.query['StoreId'];
    }
    if (this.$route.query['RONumber']) {
      this.constants.roNumber = this.$route.query['RONumber'];
    }
    if (this.$route.query['TxGuid']) {
      this.constants.txGuid = this.$route.query['TxGuid'];
    }

    this.updateStatus();
  },
  methods: {
    updateStatus() {
      switch (this.constants.status) {
        case 'Cancelled': {
          this.constants.statusMessage = ' You choose to cancel the payment';
          this.constants.alertType = 'warning';
          break;
        }
        case 'CVVNoMatch': {
          this.constants.statusMessage = 'CVV is not matched';
          this.constants.alertType = 'warning';

          break;
        }
        case 'CVVNotProcessed': {
          this.constants.statusMessage = 'CVV is not processed';
          this.constants.alertType = 'info';
          break;
        }
        case 'Approved': {
          this.constants.statusMessage =
            'Your payment is successful and an email will be sent to registered email shortly';
          this.constants.alertType = 'success';
          break;
        }
        default: {
          this.constants.statusMessage =
            'Sorry, we encountered an error. Please try after some time';
          this.constants.alertType = 'error';

          break;
        }
      }
    },
  },
};
